import Heading from "../../components/Heading";
import Button from "../../components/Button";
import Card from "../../components/Card";
import React, {useCallback} from "react";
import {useAdmin} from "../../contexts/AdminContext";
import {useGlobalContext} from "../../contexts/globalContext";
import {useTranslation} from "react-i18next";

const CompanyBox: React.FC<{className: string | undefined; edit: () => void}> = ({className, edit}) => {
    const { user, service, changeUser } = useAdmin()
    const { showToast } = useGlobalContext()
    const {t} = useTranslation(['settings'])
    const logout = useCallback(() => {
        service.logout().then(() => {
            service.setToken(null)
            showToast('top-right', 'success', t('subscription.logoutSuccessfully'))
            changeUser(null)
        })
    }, [])

    return (
        <Card classes={className}>
            <Heading level={3}>{t("subscription.companyInformation")}</Heading>
            <p><b>{t("subscription.companyName")}</b><br/>{user?.company}</p>
            <p><b>{t("subscription.firstName")}</b><br/>{user?.firstname} {user?.lastname}</p>
            <p><b>{t("subscription.street")}</b><br/>{user?.street}</p>
            <p><b>PLZ, Ort</b><br/>{user?.zipcode} {user?.city}</p>
            <p><b>{t("subscription.telephone")}</b><br/>{user?.phone}</p>
            <div className={'d-flex justify-content-between align-items-center'}>
                <Button hierarchy={'primary'} text={t("subscription.adjustData")} fn={() => edit()}/>
                <Button hierarchy={'tertiary'} text={t("subscription.logout")} fn={() => logout()}/>
            </div>
        </Card>
    )
}

export default CompanyBox
